import { FiEdit2, FiCheck } from 'react-icons/fi';
import Badge from '../../../../components/ui/Badge';

/**
 * Standard asset card actions: Pass, Fail (new), Edit result (existing).
 */
export function StandardCard({
  asset,
  sessionEntry,
  onQuickPass,
  onFailEdit,
  onEdit,
  isSyncing,
  quickPassOk,
  quickPassTooltip,
  detailsSlot,
}) {
  const tested = sessionEntry != null;
  const sessionStatus = sessionEntry?.status ?? 'pass';
  const isSynced = sessionEntry?.synced ?? false;

  const editButton = (
    <button
      type="button"
      className="btn btn-sm btn-icon"
      onClick={(e) => {
        e.stopPropagation();
        onEdit(asset, sessionEntry);
      }}
      title="Edit result"
      aria-label="Edit result"
    >
      <FiEdit2 size={16} />
    </button>
  );

  const statusBadge = sessionStatus === 'fail' ? (
    <Badge variant="danger">Failed</Badge>
  ) : (
    <Badge variant="success">Passed</Badge>
  );
  const syncIndicator = isSynced ? (
    <span className="sync-saved" title="Saved to server">
      <FiCheck size={14} aria-hidden />
    </span>
  ) : (
    <Badge variant="warning" className="sync-pending">Saving…</Badge>
  );

  return (
    <div className={`asset-card-actions ${detailsSlot && tested ? 'asset-card-actions-with-details' : ''}`}>
      {tested && (
        <>
          {detailsSlot ? (
            <>
              <div className="asset-card-actions-left">
                {statusBadge}
                {syncIndicator}
                {detailsSlot}
              </div>
              {editButton}
            </>
          ) : (
            <>
              {statusBadge}
              {syncIndicator}
              {editButton}
            </>
          )}
        </>
      )}
      {!tested && (
        <>
          <button
            type="button"
            className="btn btn-sm btn-success"
            onClick={() => onQuickPass(asset)}
            disabled={!quickPassOk || isSyncing}
            title={quickPassTooltip}
          >
            Pass
          </button>
          <button
            type="button"
            className="btn btn-sm btn-danger"
            onClick={() => onFailEdit(asset)}
          >
            Fail
          </button>
        </>
      )}
    </div>
  );
}
